module.exports = __webpack_public_path__ + "img/iam.b044944.svg";